// extracted by mini-css-extract-plugin
export default {"remove":"remove___AUTZdPz","disabled":"disabled___AUTZdPz","white":"white___AUTZdPz","blue":"blue___AUTZdPz","navy":"navy___AUTZdPz","grey":"grey___AUTZdPz"};